import { GetServerSidePropsContext } from 'next'

import { withCacheConfiguration } from '@thg-commerce/enterprise-core'
import { PageCacheConfiguration } from '@thg-commerce/enterprise-core/src/cache/configuration'

import Landing, {
  getServerSideProps as getLandingPageProps,
  LandingPageProps,
} from './landing/[...path]'

export const getServerSideProps = withCacheConfiguration<
  { props: LandingPageProps },
  GetServerSidePropsContext
>(
  async (
    context: GetServerSidePropsContext,
  ): Promise<{ props: LandingPageProps; cache?: PageCacheConfiguration }> => {
    const requestUrl = context.req.url || ''
    const pathname = requestUrl.split('?')[0]
    const enableHomeEnforcement = process.env.ENABLE_HOME_ENFORCEMENT === 'true'

    if (enableHomeEnforcement && pathname !== '/' && pathname !== '/home') {
      return {
        props: {
          path: pathname,
          statusCode: 404,
          showBackwardNavigationForBreadcrumbs: false,
          componentWidgets: [],
          pageParams: {},
        },
      }
    }
    return getLandingPageProps(context)
  },
)

export default Landing
